const axios = require("axios");
const textHelpers = require("../functions/text");
const blogUrl = require("../functions/blogUrl");
const supportSitemap = require("../functions/supportSitemap");
const { vueRedirects } = require("./redirects");

module.exports = [
  ...vueRedirects(),
  {
    path: "/",
    name: "Home",
    componentName: "Home",
  },
  {
    path: "/features",
    name: "Features",
    componentName: "Features",
  },
  {
    path: "/features/campaignbuilder",
    name: "CampaignBuilder",
    componentName: "CampaignBuilder",
  },
  {
    path: "/features/analytics",
    name: "Analytics",
    componentName: "Analytics",
  },
  {
    path: "/features/signupforms",
    name: "SignupForms",
    componentName: "SignupForms",
  },
  {
    path: "/features/landing-pages",
    name: "LandingPages",
    componentName: "LandingPages",
  },
  {
    path: "/features/websitetracking",
    name: "WebsiteTracking",
    componentName: "WebsiteTracking",
  },
  {
    path: "/features/transactionalemails",
    name: "TransactionalEmails",
    componentName: "TransactionalEmails",
  },
  {
    path: "/features/automations",
    name: "Automations",
    componentName: "Automations",
  },
  {
    path: "/features/ai-content-assistant",
    name: "AIContentAssistant",
    componentName: "AIContentAssistant",
  },
  {
    path: "/features/social-campaigns",
    name: "SocialCampaigns",
    componentName: "SocialCampaigns",
  },
  {
    path: "/features/conversations",
    name: "Conversations",
    componentName: "Conversations",
  },
  {
    path: "/features/sms",
    name: "SMS",
    componentName: "SMS",
  },
  {
    path: "/pricing",
    name: "Pricing",
    componentName: "Pricing",
  },
  {
    path: "/contactus",
    name: "ContactUs",
    componentName: "ContactUs",
  },
  {
    path: "/contacted",
    name: "Contacted",
    componentName: "Contacted",
  },
  {
    path: "/support",
    name: "SupportDocs",
    componentName: "SupportDocs",
  },
  {
    path: "/support/:collectionId",
    name: "SupportCollection",
    componentName: "SupportCollection",
    meta: {
      sitemap: {
        slugs: () => supportSitemap.getCollectionSlugs(),
      },
    },
  },
  {
    path: "/support/:collectionId/category/:categoryId",
    name: "SupportCategory",
    componentName: "SupportCategory",
    meta: {
      sitemap: {
        slugs: () => supportSitemap.getCategorySlugs(),
      },
    },
  },
  {
    path: "/support/:collectionId/:articleId",
    name: "SupportArticle",
    componentName: "SupportArticle",
    meta: {
      sitemap: {
        slugs: () => supportSitemap.getArticleSlugs(),
      },
    },
  },
  {
    path: "/blog",
    name: "Blog",
    componentName: "Blog",
  },
  {
    path: "/marketing-glossary",
    name: "MarketingGlossary",
    componentName: "MarketingGlossary",
  },
  {
    path: "/content-hub",
    name: "ContentHub",
    componentName: "ContentHub",
  },
  {
    path: "/infographics",
    name: "Infographics",
    componentName: "Infographics",
  },
  {
    path: "/webinars",
    name: "Webinars",
    componentName: "Webinars",
  },
  {
    path: "/ebooks",
    name: "Ebooks",
    componentName: "Ebooks",
  },
  {
    path: "/emailtemplates",
    name: "EmailTemplates",
    componentName: "EmailTemplates",
  },
  {
    path: "/emailtemplate/:templateId",
    name: "EmailTemplatesDetail",
    componentName: "EmailTemplatesDetail",
    meta: {
      sitemap: { ignoreRoute: true },
    },
  },
  {
    path: "/blog/:articleName/:articleId/:catchAll(.*)",
    name: "BlogArticleLegacyExtra",
    componentName: "BlogArticleFull",
    meta: {
      sitemap: { ignoreRoute: true },
    },
  },
  {
    path: "/blog/:articleName/:articleId",
    name: "BlogArticleLegacy",
    componentName: "BlogArticleFull",
    meta: {
      sitemap: { ignoreRoute: true },
    },
  },
  {
    path: "/blog/:articleName",
    name: "BlogArticleFull",
    componentName: "BlogArticleFull",
    meta: {
      sitemap: {
        slugs: async () => {
          const response = await axios.get("https://api.transpond.io/api/blog");
          const bySlug = new Map();
          response.data.Blogs.filter((blog) => blog.isPublished !== false).forEach(
            (blog) => {
              const articleName = blogUrl.articleSlug(blog);
              const existing = bySlug.get(articleName);
              if (!existing || Number(blog.id) > Number(existing.id)) {
                bySlug.set(articleName, blog);
              }
            }
          );
          return [...bySlug.values()].map((blog) => ({
            articleName: blogUrl.articleSlug(blog),
            ...(blog.updatedAt ? { lastmod: blog.updatedAt } : {}),
          }));
        },
      },
    },
  },
  {
    path: "/integrations",
    name: "Integrations",
    componentName: "Integrations",
  },
  {
    path: "/integrations/categories/:selectedCatName?",
    name: "IntegrationsCats",
    componentName: "Integrations",
    meta: {
      sitemap: {
        slugs: async () => {
          const response = await axios.get(
            "https://api.transpond.io/api/applications/categories"
          );
          return response.data.AppCats.map((categoryContainer) => ({
            selectedCatName: textHelpers.stringToSlug(
              categoryContainer.category
            ),
          }));
        },
      },
    },
  },
  {
    path: "/integrations/:appName/:appId",
    name: "IntegrationsApp",
    componentName: "IntegrationsDetail",
    meta: {
      sitemap: {
        slugs: async () => {
          const response = await axios.get(
            "https://api.transpond.io/api/applications"
          );

          return response.data.Applications.map((app) => ({
            appName: textHelpers.stringToSlug(app.appName + " email marketing"),
            appId: app.id,
          }));
        },
      },
    },
  },
  {
    path: "/about",
    name: "AboutUs",
    componentName: "About",
  },
  {
    path: "/media",
    name: "BrandResources",
    componentName: "BrandResources",
  },
  {
    path: "/videos",
    name: "Videos",
    componentName: "Videos",
  },
  {
    path: "/terms",
    name: "Terms",
    componentName: "Terms",
  },
  {
    path: "/daa_terms",
    name: "TermsDAA",
    componentName: "TermsDAA",
  },
  {
    path: "/ai_terms",
    name: "TermsAI",
    componentName: "TermsAI",
  },
  {
    path: "/privacy",
    name: "Privacy",
    componentName: "Privacy",
  },
  {
    path: "/dpa",
    name: "DPA",
    componentName: "Dpa",
  },
  {
    path: "/dpa_restrictedtransfers",
    name: "DPARestrictedTransfers",
    componentName: "DpaRestricted",
  },
  {
    path: "/dpa_schedule1",
    name: "DPASchedule1",
    componentName: "DpaSchedule1",
  },
  {
    path: "/dpa_schedule2",
    name: "DPASchedule2",
    componentName: "DpaSchedule2",
  },
  {
    path: "/dpa_schedule3",
    name: "DPASchedule3",
    componentName: "DpaSchedule3",
  },
  {
    path: "/dpa_cancellation",
    name: "CancellationPolicy",
    componentName: "DpaCancellation",
  },
  {
    path: "/subprocessors",
    name: "SubProcessors",
    componentName: "TermsSubProcessors",
  },
  {
    path: "/gdprcontactlocations",
    name: "GDPRContactLocations",
    componentName: "GDPRContactLocations",
  },
  {
    path: "/cookiepolicy",
    name: "CookiePolicy",
    componentName: "TermsCookiePolicy",
  },
  {
    path: "/acceptableuse",
    name: "AcceptableUsePolicy",
    componentName: "TermsAcceptableUse",
  },
  {
    path: "/thirdparties",
    name: "ThirdParties",
    componentName: "TermsThirdParties",
  },
  {
    path: "/reseller_dpa",
    name: "ResellerDPA",
    componentName: "TermsResellerDPA",
  },
  {
    path: "/reseller_agreement",
    name: "ResellerAgreement",
    componentName: "TermsReseller",
  },
  {
    path: "/affiliate_terms",
    name: "AffiliateTerms",
    componentName: "TermsAffiliates",
  },
  {
    path: "/sms_terms",
    name: "TextMessagingTerms",
    componentName: "TextMessagingTerms",
  },
  {
    path: "/mailchimp-alternative",
    name: "MailchimpAlternative",
    componentName: "MailchimpAlternative",
  },
  {
    path: "/partner-program",
    name: "PartnerProgram",
    componentName: "PartnerProgram",
  },
  {
    path: "/whitelabel",
    name: "WhitelabelLanding",
    componentName: "WhiteLabelLanding",
  },
  {
    path: "/marketing-for-agencies",
    name: "MarketingForAgencies",
    componentName: "MarketingForAgencies",
  },
  {
    path: "/saas-rise",
    name: "SaasRise",
    componentName: "SaasRise",
  },
  {
    path: "/ebooks/smb-marketing-blueprint",
    name: "SmbMarketingBlueprint",
    componentName: "SmbMarketingBlueprint",
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/",
  },
];
